<template>
  <div class="enterpriseWorkbench">
    <van-form label-width="120px">
      <van-field v-model="form.UserName" :label="$t.workbench.username" readonly />
      <van-field v-model="form.RoleName" :label="$t.workbench.roleName" readonly />
      <van-field v-model="form.PhoneNumber" :label="$t.workbench.phoneNumber" readonly />
      <van-field v-model="form.CompanyName" :label="$t.workbench.companyName" type="textarea" rows="5" readonly />
      <van-field :label="$t.workbench.eCard">
        <template #input>
          <van-image width="80" height="80" :src="qrCode" @click="qrcodePreview(qrCode)" />
        </template>
        <template #button>
          <van-button size="small" type="info" @click="onSaveQrCode" v-if="isApp && qrCode">{{ $t.meta.saveToAlbum
          }}</van-button>
        </template>
      </van-field>

      <van-field :label="$t.workbench.h5QrCode">
        <template #input>
          <van-image width="80" height="80" :src="h5Code" @click="qrcodePreview(h5Code)" />
        </template>
        <template #button>
          <van-button size="small" type="info" @click="onSaveH5QrCode" v-if="isApp && h5Code">{{ $t.meta.saveToAlbum
          }}</van-button>
        </template>
      </van-field>

      <van-cell :title="$t.workbench.freightPriceCalculator" is-link @click="gotoCalculator" />

      <van-cell :title="$t.workbench.createRequest" is-link @click="gotoPayrollList" />

      <van-cell :title="$t.workbench.viewButton" is-link @click="gotoFinancialRequest" />

      <van-cell :title="$t.workbench.myBankAccount" is-link @click="gotoWorkBenchBank" />

      <van-cell :title="$t.workbench.supplierCollector" is-link @click="gotoWorkBenchSupplier" />
    </van-form>
  </div>
</template>
<script>
import Vue from "vue";
import { Form, Field, Cell, Button, Icon, Image, ImagePreview } from "vant";
import { isAPP } from "@/plugins/environment/type.js";

Vue.use(Form).use(Field).use(Cell).use(Button).use(Icon).use(Image).use(ImagePreview);

export default {
  name: "enterpriseWorkbench",
  data() {
    return {
      UserId: JSON.parse(localStorage.getItem("auth")).userInfo.UserId,
      CompanyCode: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyCode,
      isApp: isAPP(),
      form: {
        UserName: JSON.parse(localStorage.getItem("auth")).userInfo.UserName,
        RoleName: JSON.parse(localStorage.getItem("auth")).userInfo.RoleName,
        PhoneNumber: JSON.parse(localStorage.getItem("auth")).userInfo.PhoneNumber,
        CompanyName: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyName,
      },
      qrCode: "",
      shareQrCode: "",
      h5Code: "",
    };
  },
  created() {
    this.getQrCode();
    this.getH5QrCode();
    this.loadMyWorkbench();
  },
  methods: {
    onSaveH5QrCode() {
      var element = document.createElement("img");
      element.setAttribute("src", this.h5Code);
      this.$commonEnv.commonAction(this.$commonEnv.actionType.downloadImage, {
        element: element,
        successText: this.$t.meta.saveSuccess,
        failText: this.$t.meta.saveError,
      });
    },
    onSaveQrCode() {
      var element = document.createElement("img");
      element.setAttribute("src", this.qrCode);
      this.$commonEnv.commonAction(this.$commonEnv.actionType.downloadImage, {
        element: element,
        successText: this.$t.meta.saveSuccess,
        failText: this.$t.meta.saveError,
      });
    },
    gotoWorkBenchSupplier() {
      localStorage.setItem("workbenchSupplier", JSON.stringify(this.form));
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: false,
        path: "workbenchSupplier",
        name: "workbenchSupplier",
        query: [],
      });
    },
    gotoWorkBenchBank() {
      localStorage.setItem("workbenchBank", JSON.stringify(this.form));
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: false,
        path: "workbenchBank",
        name: "workbenchBank",
        query: [],
      });
    },
    gotoFinancialRequest() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "financialRequest",
        name: "financialRequest",
        query: [
          {
            name: "isWorkbench",
            value: true,
          },
        ],
      });
    },
    gotoPayrollList() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: false,
        path: "payrollList",
        name: "payrollList",
        query: [],
      });
    },
    gotoCalculator() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: false,
        path: "freightPriceCalculator",
        name: "freightPriceCalculator",
        query: [],
      });
    },
    qrcodePreview(data) {
      ImagePreview({ images: [data], closeable: true, startPosition: 0 });
    },
    imgUrlFilter(value) {
      return this.$api.formatImageUrl(value);
    },
    getQrCode() {
      var param = { WebSiteUrl: "" };
      this.$api.myHome.userSharingQrCode(param).then((res) => {
        this.qrCode = "data:image/png;base64," + res.data;
      });
    },
    getH5QrCode() {
      var url =
        "web/auth/register?CompanyCode=" +
        this.CompanyCode +
        "&UserId=" +
        this.UserId;
      var param = {
        WebSiteUrl: "https://express.vtrack.top/" + url,
      };
      this.$api.myHome.getQrCodeByBase64(param).then((res) => {
        this.h5Code = "data:image/png;base64," + res.data;
      });
    },
    loadMyWorkbench() {
      this.$commonMethod.showLoading();
      var param = {
        UserId: this.UserId,
      };
      this.$api.myHome
        .loadMyWorkbench(param)
        .then((res) => {
          this.form = res.data;
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.enterpriseWorkbench {
  .avatarImg {
    width: 50px;
    height: 50px;
  }

  .van-cell {
    border-bottom: 1px solid #ebedf0;
  }

  .van-cell::after {
    border: none !important;
  }

  ::v-deep .van-collapse-item__content {
    padding: 0px 15px 15px 15px;
    background: transparent;
    border-top: 1px solid #ebedf0;
  }

  ::v-deep .van-collapse {
    border-bottom: 1px solid #ebedf0;
  }

  ::v-deep .van-collapse::after {
    border: none !important;
  }

  ::v-deep .van-collapse-item__title--expanded::after {
    display: none !important;
  }
}
</style>
